module.exports = __webpack_public_path__ + "static/media/logo.ff2493b9.png";